import Schema from "nexia_mobile/models/schema";

export default {
  parseLinksAutomate(links) {
    let link = _.first(links);
    let schema;
    if (link == null) {
      schema = null;
    } else {
      schema = new Schema(link.getData(), { parse: true });
      schema.setStoredOnServer(link.isPostLink());
      schema.setUrl(link.href);
    }

    return { automateSchema: schema };
  },

  canBeAutomated() {
    return this.get("automateSchema") != null;
  },

  createAutomateSchema() {
    return this.get("automateSchema").prepare();
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/automatable.js